import { NotificationManager } from "react-notifications";

export default function handleChangeFile(
  { setFiles, isOverride = false, reset = false, isReducer = false },
  evt
) {
  const filesTemp = [];
  for (let fileIdx = 0; fileIdx < evt.target.files?.length; fileIdx += 1) {
    const element = evt.target.files[fileIdx];
    const url = window.URL.createObjectURL(element);
    const { name } = element;
    if (element.size > 10485760) {
      NotificationManager.error("لا يجوز رفع ملفات بحجم أكبر من 10MB");
    } else {
      filesTemp.push({
        url,
        name,
        date: new Date().toDateString(),
        inputFile: element,
      });
    }
  }

  // eslint-disable-next-line no-param-reassign
  if (reset) evt.target.value = "";

  // in case using normal state
  if (!isReducer)
    if (filesTemp?.length > 0) {
      if (!isOverride) setFiles((prevFiles) => [...prevFiles, ...filesTemp]);
      else setFiles(filesTemp);
    }

  // in case using Reducer
  if (isReducer) {
    if (filesTemp?.length > 0) {
      // in case reducer the setFiles will be array of files not a function
      if (isOverride) return [...setFiles, ...filesTemp];
      return filesTemp;
    }
  }
  return null;
}
